<template>
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams" class="-mb-15px" label-width="68px">
      <el-form-item label="会员昵称" prop="nickname">
        <el-input v-model="queryParams.nickname" class="!w-200px" clearable placeholder="请输入会员昵称" @keyup.enter="handleQuery" />
      </el-form-item>
      <el-form-item label="领取时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          class="!w-240px"
          end-placeholder="结束日期"
          start-placeholder="开始日期"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
        <el-button @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-tabs v-model="activeTab" type="card" @tab-change="onTabChange">
      <el-tab-pane v-for="tab in statusTabs" :key="tab.value" :label="tab.label" :name="tab.value" />
    </el-tabs>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="会员昵称" align="center" min-width="100" prop="nickname" />
      <el-table-column label="优惠券名称" align="center" min-width="140" prop="name" />
      <el-table-column label="范围" align="center" prop="productScope">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.PROMOTION_PRODUCT_SCOPE" :value="scope.row.productScope" />
        </template>
      </el-table-column>
      <el-table-column label="优惠" min-width="120">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.PROMOTION_DISCOUNT_TYPE" :value="scope.row.discountType" />
          {{ discountFormat(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.PROMOTION_COUPON_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column label="领取时间" align="center" prop="createTime" :formatter="dateFormatter" width="180" />
      <el-table-column label="使用时间" align="center" prop="useTime" :formatter="dateFormatter" width="180" />
    </el-table>
    <Pagination v-model:limit="queryParams.pageSize" v-model:page="queryParams.pageNo" :total="total" @pagination="getList" />
  </ContentWrap>
</template>

<script setup lang="ts">
import { getCouponTakePage } from '@/api/merchant/promotion'
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import { discountFormat } from '@/views/mall/promotion/coupon/formatter'

defineOptions({ name: 'MerchantCouponRecord' })

const router = useRouter()
const loading = ref(true)
const total = ref(0)
const list = ref([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  createTime: [],
  status: undefined as number | undefined,
  nickname: undefined as string | undefined,
  bizType: 'MALL'
})
const queryFormRef = ref()
const activeTab = ref('all')
const statusTabs = reactive([{ label: '全部', value: 'all' }])

const getList = async () => {
  loading.value = true
  try {
    const data = await getCouponTakePage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  activeTab.value = 'all'
  queryParams.status = undefined
  handleQuery()
}

const onTabChange = (tabName: string) => {
  queryParams.status = tabName === 'all' ? undefined : Number(tabName)
  getList()
}

const goBack = () => router.push({ name: 'MerchantPromotion' })

onMounted(() => {
  getList()
  for (const dict of getIntDictOptions(DICT_TYPE.PROMOTION_COUPON_STATUS)) {
    statusTabs.push({ label: dict.label, value: String(dict.value) })
  }
})
</script>
